import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function deleteUser(): Promise<void> {
  try {
    await axios.delete("/users");
  } catch (error) {
    throwSylaApiError(error);
  }
}
